import {
  Alert,
  AlertIcon,
  Box,
  Center,
  Heading,
  Spinner,
  Text,
  Flex,
  Stack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFocusOnLngLat } from "../../hooks/useFocusOnLngLat";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import BackButton from "../../components/BackButton";
import { WelcomeWeekEvent } from "../../types/welcomeWeekTypes";
import { getPinEvents } from "../../data/welcomeEvents.api";
import WelcomeCard from "../../components/welcomeProgramme/WelcomeCard";

const ViewWelcomePins = () => {
  const { location } = useParams<{ location: string }>();
  const [longitude, setLongitude] = useState<number>();
  const [latitude, setLatitude] = useState<number>();
  const [pinEvents, setEventsOnPin] = useState<WelcomeWeekEvent[]>([]);
  const [loading, setLoading] = useState<boolean>(true); // Loading state
  const [error, setError] = useState<string | null>(null); // Error state
  //   const [mapEvents, setMapEvents] = useState<WelcomeWeekEvent[]>([]);
  //   const [loading, setLoading] = useState<boolean>(true); // Loading state
  //   const [error, setError] = useState<string | null>(null); // Error state

  useEffect(() => {
    async function fetchPinEvents() {
      setLoading(true); // Set loading to true before starting data fetching
      setError(null); // Reset error before fetching
      try {
        const locationParts = location?.split("_"); // Split the string at the underscore
        const lat = Number(locationParts?.[0]);
        const long = Number(locationParts?.[1]);
        setLatitude(lat);
        setLongitude(long);
        const EventsOnPin = getPinEvents(long, lat);
        setEventsOnPin(await EventsOnPin);
      } catch (error) {
        setError("Failed to load events data");
      } finally {
        setLoading(false); // Stop loading after fetch attempt
      }
    }
    fetchPinEvents();
  }, [location]);

  useFocusOnLngLat(longitude, latitude, undefined, 17.5);

  return (
    <HybridBottomSheetDrawer ml={"4em"}>
      <BackButton />

      <Box p={8}>
        <Flex mb={4} justify="space-between" align="center">
          <Heading size="md">Events on Pin</Heading>
        </Flex>
        {loading ? (
          <Center>
            <Spinner />
          </Center>
        ) : error ? (
          <Alert status="error">
            <AlertIcon />
            {error}
          </Alert>
        ) : pinEvents.length > 0 ? (
          <Stack spacing={4}>
            {pinEvents.map((event) => (
              <WelcomeCard key={event.id} event={event} />
            ))}
          </Stack>
        ) : (
          <Text>Cannot find events on this pin</Text>
        )}
      </Box>
    </HybridBottomSheetDrawer>
  );
};

export default ViewWelcomePins;
